var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Link } from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import axios from "axios";
import AuthLayout from '../components/AuthLayout';
const AcceptInvite = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [token, setToken] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [declineOpen, setDeclineOpen] = useState(false);
    const [declined, setDeclined] = useState(false);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlToken = urlParams.get('token');
        if (urlToken) {
            setToken(urlToken);
        }
        else {
            setSnackbarSeverity('error');
            setSnackbarMessage('Ссылка-приглашение отсутствует или неверна.');
            setOpenSnackbar(true);
        }
    }, []);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const handleKeyDown = (key) => {
        if (key === 'Enter') {
            submit();
        }
    };
    const submit = () => {
        if (isSubmitting)
            return;
        if (firstName === "" || lastName === "" || password === "" || confirmPassword === "") {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пожалуйста, заполните все поля.');
            setOpenSnackbar(true);
            return;
        }
        if (password !== confirmPassword) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пароли не совпадают.');
            setOpenSnackbar(true);
            return;
        }
        if (password.length < 6) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Пароль должен содержать минимум 6 символов.');
            setOpenSnackbar(true);
            return;
        }
        if (!token) {
            setSnackbarSeverity('error');
            setSnackbarMessage('Ссылка-приглашение отсутствует или неверна.');
            setOpenSnackbar(true);
            return;
        }
        setIsSubmitting(true);
        axios({
            method: "post",
            url: "/auth/accept-invite",
            data: {
                token: token,
                password: password,
                first_name: firstName,
                last_name: lastName
            },
            headers: { "Content-Type": "application/json" },
        })
            .then(function (response) {
            if (response.data.success) {
                window.history.replaceState({}, '', window.location.pathname);
                setToken('');
                setSnackbarSeverity('success');
                setSnackbarMessage(response.data.message || 'Регистрация завершена. Ожидайте назначения роли администратором.');
                setOpenSnackbar(true);
                setTimeout(() => window.location.href = '/login', 2500);
            }
            else {
                setSnackbarSeverity('error');
                setSnackbarMessage(response.data.message || 'Не удалось завершить регистрацию.');
                setOpenSnackbar(true);
                setIsSubmitting(false);
            }
        })
            .catch(function (error) {
            var _a, _b;
            setSnackbarSeverity('error');
            setSnackbarMessage(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || "Произошла ошибка при завершении регистрации");
            setOpenSnackbar(true);
            setIsSubmitting(false);
        });
    };
    const decline = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        if (!token || isSubmitting)
            return;
        setIsSubmitting(true);
        try {
            const response = yield axios.post('/auth/decline-invite', { token });
            if (((_a = response.data) === null || _a === void 0 ? void 0 : _a.success) === false) {
                throw new Error(((_b = response.data) === null || _b === void 0 ? void 0 : _b.message) || 'Не удалось отклонить приглашение.');
            }
            window.history.replaceState({}, '', window.location.pathname);
            setToken('');
            setDeclined(true);
            setSnackbarSeverity('success');
            setSnackbarMessage('Приглашение отклонено. Ссылка больше не действует.');
            setOpenSnackbar(true);
        }
        catch (error) {
            setSnackbarSeverity('error');
            setSnackbarMessage(((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.detail) || error.message || 'Не удалось отклонить приглашение.');
            setOpenSnackbar(true);
        }
        finally {
            setIsSubmitting(false);
            setDeclineOpen(false);
        }
    });
    return (React.createElement(AuthLayout, { snackbarOpen: openSnackbar, snackbarMessage: snackbarMessage, snackbarSeverity: snackbarSeverity, onCloseSnackbar: handleCloseSnackbar },
        React.createElement("div", { style: { marginBottom: '30px' } },
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: '30px' } },
                    React.createElement(Typography, { variant: 'h5', gutterBottom: true }, declined ? 'Приглашение отклонено' : 'Завершение регистрации'),
                    React.createElement(Typography, { variant: 'body1' }, declined
                        ? 'Приглашение удалено, ссылка больше не действует. Учётная запись не создана.'
                        : 'Вас пригласили присоединиться к платформе. Укажите имя и задайте пароль.')),
                !declined && React.createElement("div", null,
                    React.createElement(Stack, { spacing: 1 },
                        React.createElement(TextField, { required: true, id: "first-name-input", label: "\u0418\u043C\u044F", onChange: (e) => setFirstName(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting }),
                        React.createElement(TextField, { required: true, id: "last-name-input", label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F", onChange: (e) => setLastName(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting }),
                        React.createElement(TextField, { required: true, id: "password-input", label: "\u041F\u0430\u0440\u043E\u043B\u044C", type: "password", onChange: (e) => setPassword(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting }),
                        React.createElement(TextField, { required: true, id: "confirm-password-input", label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", type: "password", onChange: (e) => setConfirmPassword(e.target.value), onKeyDown: (e) => handleKeyDown(e.key), disabled: !token || isSubmitting })),
                    React.createElement("div", { className: "submitMargin" },
                        React.createElement(Stack, { direction: { xs: 'column', sm: 'row' }, spacing: 1 },
                            React.createElement(Button, { onClick: () => submit(), variant: "contained", disabled: !token || isSubmitting }, "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E"),
                            React.createElement(Button, { color: "error", onClick: () => setDeclineOpen(true), disabled: !token || isSubmitting }, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435"))),
                    React.createElement("div", { style: { marginTop: '20px' } },
                        React.createElement(Typography, { variant: 'body2' },
                            "\u0423\u0436\u0435 \u0435\u0441\u0442\u044C \u0443\u0447\u0451\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C?",
                            ' ',
                            React.createElement(Link, { href: "/login", style: { cursor: 'pointer' } }, "\u0412\u043E\u0439\u0442\u0438")))),
                declined && React.createElement(Link, { href: "/login" }, "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0432\u0445\u043E\u0434\u0430"))),
        React.createElement(Dialog, { open: declineOpen, onClose: () => !isSubmitting && setDeclineOpen(false) },
            React.createElement(DialogTitle, null, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435?"),
            React.createElement(DialogContent, null,
                React.createElement(Typography, { variant: "body2" }, "\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0438 \u0441\u0441\u044B\u043B\u043A\u0430 \u0431\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B. \u0414\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F \u043D\u043E\u0432\u043E\u0435 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435.")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: () => setDeclineOpen(false), disabled: isSubmitting }, "\u041D\u0430\u0437\u0430\u0434"),
                React.createElement(Button, { color: "error", onClick: decline, disabled: isSubmitting }, "\u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435")))));
};
export default AcceptInvite;
